import React from "react";
import { createPortal } from "react-dom";

import { APP_SCROLL_ID } from "../utils/appScroll";

/** Positions transient page notices over the app's content column. */
const BottomToastPortal = ({ children }: { children: React.ReactNode }) =>
  createPortal(
    <div
      className="pointer-events-none fixed bottom-8 right-0 z-[100] flex justify-center px-4"
      style={{
        left: document.getElementById(APP_SCROLL_ID)?.getBoundingClientRect().left ?? 0,
      }}
    >
      {children}
    </div>,
    document.body,
  );

export default BottomToastPortal;
